import Phaser from "phaser";

/**
 * Programmatic textures that are not covered by the art pack (a 1×1 pixel for bars/overlays).
 * Everything else comes from the Ninja Adventure pack via PreloadScene; see public/assets/CREDITS.md.
 */
export function makePlaceholders(scene: Phaser.Scene): void {
  if (scene.textures.exists("pixel")) return;
  const g = scene.make.graphics({ x: 0, y: 0 }, false);
  g.fillStyle(0xffffff);
  g.fillRect(0, 0, 1, 1);
  g.generateTexture("pixel", 1, 1);
  g.destroy();
}
